<script lang="ts">
	setTimeout(() => {
		let map = new OpenLayers.Map("demoMap");
		var mapnik = new OpenLayers.Layer.OSM();
		var fromProjection = new OpenLayers.Projection("EPSG:4326");   // Transform from WGS 1984
		var toProjection = new OpenLayers.Projection("EPSG:900913"); // to Spherical Mercator Projection
		var position = new OpenLayers.LonLat(-0.055310, 51.497469).transform(fromProjection, toProjection);
		var zoom = 14;

		map.addLayer(mapnik);
		map.setCenter(position, zoom);
	}, 1);

	setInterval(() => {
		window.location.reload();
	}, 60000);

	const monthNames = ["January", "February", "March", "April", "May", "June",
		"July", "August", "September", "October", "November", "December"
	];

	const today = new Date();
	const date1 = `${today.getDate() + 2} ${monthNames[today.getMonth()]}`;
	const date2 = `${today.getDate() + 3} ${monthNames[today.getMonth()]}`;
</script>

<main>
	<h1><i class="fas fa-biking"></i> welcome to twintwinroo</h1>
	<p>Order your meal to deliver here.</p>
	<p><em>Keep tab open for live updates.</em></p>

	<ul class="menu">
		<li class="dish">
			<img width="350" class="image" src="./images/crbst_boulets.jpg" alt="boulets" />
			<h3>Boulets à la liégeoise</h3>
			<p>Delicious pork and beef meat balls served with a sweet sauce made of sirop de Liège.</p>
			<p>Quantity
			<select name="qty[boulet]">
				<option>2</option>
				<option>4</option>
				<option>6</option>
				<option>8</option>
				<option>10</option>
			</select></p>
		</li>
		<li class="dish">
			<img width="350" class="image" src="./images/tarteauriz.jpg" alt="tarteauriz" />
			<h3>Tarte Au Riz</h3>
			<p>Rice pudding on pie. You had to wait for the Verviétois to invent it.</p>
			<p>
			Quantity
			<select name="qty[tarte]">
				<option>1 slice</option>
				<option>2 slices</option>
				<option>half pie</option>
				<option>full pie</option>
			</select></p>
		</li>
		<li class="dish">
			<h3>Confirm address and date for delivery</h3>

			<input type="text" name="address" placeholder="Post code">

			<select>
				<option value="{date1}">{date1}</option>
				<option value="{date2}">{date2}</option>
			</select>

			<button class="primary">
				Place order
			</button>
		</li>
	</ul>

	<div id="demoMap" style="display: none; height:500px;width: 100%; background: transparent"></div>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #715ac1;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	ul.menu {
		list-style-type: none;
	}

	ul.menu li.dish {
		clear: both;
		margin: 2em 0;
		display: block;
		position: relative;
	}

	ul.menu .image {
		display: inline-block;
		float: right;
		margin: 2em 0;
	}

	ul.menu li:after {
		clear: both;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>